export default "<p>\r\n {{ 'POSTPAID_MONTHLY_MESSAGE' | translate }}\r\n</p>\r\n";